import React from "react";

const SvgBuilding = ({ color = "currentColor", ...props }) => (
  <svg width="18" viewBox="0 0 18 18" {...props}>
    <path
      d="M16.2 14.389v1.8h-1.8V2.7H9.9V0H8.1v2.7H3.61v13.491h-1.8v-1.8H.01v3.6H18v-3.6h-1.8zm-6.3 1.8v-3.6H8.1v3.6H5.41V4.5h7.19v11.692H9.9zM8.1 8.994h1.8v1.8H8.1v-1.8zm0-3.6h1.8v1.8H8.1v-1.8z"
      fill={color || "currentColor"}
      fillRule="evenodd"
    />
  </svg>
);

export default SvgBuilding;
